import React, { useState } from "react";
import { ICard } from "../../interfaces/card";
import { IFilter } from "../../interfaces/filter";
import { toUpperCaseFirstLetter } from "./utils";
import { filterDefault } from "../../data/filterDefault";
import './style.css';

type PanelProps = {
    cards: ICard[];
    filter: IFilter;
    filterCallback: (value: IFilter) => void;
    loaded: boolean;
};

export function Panel( props: PanelProps) {
    const[filters,setFilters] = useState<IFilter>(props.filter);

    const setCatagory = (e: HTMLInputElement) => {
        const { name, key, value } = getCategoryOrRateValues(e);
        if (name !== `category` || (
            key !== `electronics` &&
            key !== `men's clothing` &&
            key !== `jewelery` &&
            key !== `women's clothing`)) return;
        const newValue = filters;
        newValue[name][key] = value;
        setFilters(newValue);
        sendFilters();
    }

    const setRate = (e: HTMLInputElement) => {
        const { name, key, value } = getCategoryOrRateValues(e);
        if (name !== `rate` || (
            key !== `1` &&
            key !== `2` &&
            key !== `3` &&
            key !== `4` &&
            key !== `5`)) return;
        const newValue = filters;
        newValue[name][key] = value;
        setFilters(newValue);
        sendFilters();
    }
    
    const getCategoryOrRateValues = (e: HTMLInputElement) => {
        return {name: e.name, key: e.value, value: e.checked};
    }

    const setPriceOrCount = (e: HTMLInputElement) => {
        const [name, key] = e.id.split('-') as [`price`|`counts`,`min`|`max`];
        const sliders = document.querySelectorAll(`input[name="${name}"]`) as NodeListOf<HTMLInputElement>;

        if(key === "min") {
            if( sliders[0].valueAsNumber > sliders[1].valueAsNumber){
                sliders[1].valueAsNumber = sliders[0].valueAsNumber;
            }
        }
        if(key === "max") {
            if( sliders[1].valueAsNumber < sliders[0].valueAsNumber){
                sliders[0].valueAsNumber = sliders[1].valueAsNumber;
            }
        }
        const newValue = filters;
        const value = { min: sliders[0].valueAsNumber, max: sliders[1].valueAsNumber };
        newValue[name] = value;
        setFilters(newValue);
        sendFilters();
    }

    const setSearch = (e: HTMLInputElement) => {
        const newValue = filters;
        const value = e.value;
        newValue.search = value;
        setFilters(newValue);
        sendFilters();
    }

    const setSort = (e: HTMLSelectElement) => {
        const newValue = filters;
        const [by, order] = e.value.split('-');
        if (by !== '' && by !== 'rate' && by !== 'price' && by !== 'title') return;
        if (order !== '' && order !== 'asc' && order !== 'desc') return;
        newValue.sort.by = by;
        newValue.sort.order = order;
        setFilters(newValue);
        sendFilters();
    }

    const sendFilters = () => {
        props.filterCallback(filters);
    }

    const tooglePanel = (e: HTMLInputElement) => {
        if (e.classList.contains('panel')) {
            e.classList.toggle('show');
        }
    }

    const resetFilters = () => {
        const search = (document.querySelector('#search') as HTMLInputElement);
        search.value = filterDefault.search;
        setSearch(search);
        document.querySelectorAll(`input[name=category]`).forEach(input => {
            (input as HTMLInputElement).checked = false;
            setCatagory(input as HTMLInputElement);
        });
        document.querySelectorAll(`input[name=rate]`).forEach(input => {
            (input as HTMLInputElement).checked = false;
            setRate(input as HTMLInputElement);
        });
        document.querySelectorAll(`input[name=price]`).forEach(input => {
            (input as HTMLInputElement).value = `${input.id === `price-min` ? filterDefault.price.min : filterDefault.price.max}`;
            setPriceOrCount(input as HTMLInputElement);
        });
        document.querySelectorAll(`input[name=counts]`).forEach(input => {
            (input as HTMLInputElement).value = `${input.id === `counts-min` ? filterDefault.counts.min : filterDefault.counts.max}`;
            setPriceOrCount(input as HTMLInputElement);
        });
        const sort = (document.querySelector('#sort') as HTMLSelectElement);
        sort.selectedIndex = 0;
        setSort(sort);
    }

    return (
        <div className={`panel ${props.loaded ? 'loaded' : ''}`} onClick={(e) => tooglePanel(e.target as HTMLInputElement)}>
            <div className="wrapper">
                <div className="value-filters">
                    <div className="value-filters-wrapper">
                        <h2 className="heading">Value filters</h2>
                        { Object.keys(filterDefault)
                            .filter((_,index) => index < 2)
                            .map((valueName, index) => (
                                <div className={`${valueName}-wrapper`} key = {`key-${valueName}-${index}`}>
                                    <h3 className="heading">{`${toUpperCaseFirstLetter(valueName)}:`}</h3>
                                    <div className={`${valueName}-labels-wrapper`}>
                                        {Object.keys(filterDefault[valueName as `category`|`rate`]).map((value,index) => (
                                            <div className = {`${valueName}-${index+1}`} key = {`${valueName}-${index+1}`}>
                                                <input type = "checkbox"
                                                    id = {`${valueName}-${index+1}`}
                                                    value = {value}
                                                    name = {`${valueName}`}
                                                    onChange = {valueName === `category` ?
                                                        (e) => setCatagory(e.target as HTMLInputElement) :
                                                        (e) => setRate(e.target as HTMLInputElement)}
                                                />
                                                <label htmlFor={`${valueName}-${index+1}`} className="label">
                                                    <span className="label-value">{toUpperCaseFirstLetter(value)}</span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>

                <div className="range-filters">
                    <h2 className="heading">Range filters</h2>
                    <div className="range-filters-wrapper">
                        <div className="price-filter" key = "key-price-1">
                            <h3 className="heading">Price</h3>
                            <div className = "price-filter-wrapper">
                                <span>{filters.price.min}</span>
                                <div className="input-wrapper">
                                    <input type = "range" step = "1"
                                        name = "price" id="price-min"
                                        min = {0}
                                        max = {1000}
                                        value = {filters.price.min}
                                        onInput = {(e) => setPriceOrCount(e.target as HTMLInputElement)}
                                    />
                                    <input type = "range" step = "1"
                                        name = "price" id="price-max"
                                        min = {0}
                                        max = {1000}
                                        value = {filters.price.max}
                                        onInput = {(e) => setPriceOrCount(e.target as HTMLInputElement)}
                                    />
                                </div>
                                <span>{filters.price.max}</span>
                            </div>
                        </div>

                        <div className="counts-filter" key = "key-counts-2">
                            <h3 className="heading">Counts</h3>
                            <div className = "counts-filter-wrapper">
                                <span>{filters.counts.min}</span>
                                <div className="input-wrapper">
                                    <input type = "range" step = "1"
                                        name = "counts" id="counts-min"
                                        min = {0}
                                        max = {500}
                                        value = {filters.counts.min}
                                        onInput = {(e) => setPriceOrCount(e.target as HTMLInputElement)}
                                    />
                                    <input type = "range" step = "1"
                                        name = "counts" id="counts-max"
                                        min = {0}
                                        max = {500}
                                        value = {filters.counts.max}
                                        onInput = {(e) => setPriceOrCount(e.target as HTMLInputElement)}
                                    />
                                </div>
                                <span>{filters.counts.max}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="search-filter-sort">
                    <h2 className="heading">Search and sort</h2>
                    <div className="search-filter-sort-wrapper">
                        <div className="search-filter">
                            <input type="search" name="search" id="search" 
                                placeholder="Search.." autoComplete = "off" autoFocus = {true}
                                onChange={(e) => setSearch(e.target as HTMLInputElement)}/>
                        </div>
                        <div className="sort">
                            <select name="sort" id="sort" onChange={(e) => setSort(e.target)}>
                                <option className="sort-option" value="-">Sort ... (default random)</option>
                                <option className="sort-option" value="title-asc">Sort by name (from A to Z)</option>
                                <option className="sort-option" value="title-desc">Sort by name (from Z to A)</option>
                                <option className="sort-option" value="rate-asc">Sort by rate (from Min to Max)</option>
                                <option className="sort-option" value="rate-desc">Sort by rate (from Max to Min)</option>
                                <option className="sort-option" value="price-asc">Sort by price (from Min to Max)</option>
                                <option className="sort-option" value="price-desc">Sort by price (from Max to Min)</option>
                            </select>
                        </div>
                    </div>
                    <button id ="reset"
                        onClick ={resetFilters}
                    >Reses all filters</button>
                </div>
            </div>
        </div>
    );
}
